import { Injector, ModuleWithProviders } from '@angular/core';
import { LayoutService } from './layout.service/layout.service';
import { Router } from '@angular/router';
import { defaultConfig } from './layout-config';
import * as i0 from "@angular/core";
export const LAYOUT_CONFIG_PROVIDER = 'LAYOUT_CONFIG_PROVIDER';
export function configFactory(injector) {
  const providedConfig = injector.get('dynamic_layout_config');
  return {
    ...defaultConfig,
    ...providedConfig
  };
}
export let LayoutFrontendSharedModule = /*#__PURE__*/(() => {
  class LayoutFrontendSharedModule {
    static forRoot(config) {
      return {
        ngModule: LayoutFrontendSharedModule,
        providers: [{
          provide: 'dynamic_layout_config',
          // you can also use InjectionToken
          useValue: config
        }, {
          provide: LAYOUT_CONFIG_PROVIDER,
          useFactory: configFactory,
          deps: [Injector, 'dynamic_layout_config']
        }, {
          provide: LayoutService,
          useClass: LayoutService,
          deps: [LAYOUT_CONFIG_PROVIDER, Router]
        }]
      };
    }
    static {
      this.ɵfac = function LayoutFrontendSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LayoutFrontendSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: LayoutFrontendSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({});
    }
  }
  return LayoutFrontendSharedModule;
})();